// Duits (de-DE), householdsApp: zelfde vorm als householdsApp.nl.ts (golf 6b). Wat ontbreekt valt
// terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const appHouseholdsDe = {
    question: 'Wer wohnt im Haus?',
    questionBody: 'Dann richten wir ein, was zu euch passt. Du kannst später alles ändern, es geht nie etwas verloren.',
    types: {
        family: {
            name: 'Familie mit Kindern',
            body: 'Eltern mit Kindern. Kalender, Aufgaben mit Sternen, Bringen und Abholen.',
        },
        two_home: {
            name: 'Familie mit zwei Zuhause',
            body: 'Die Kinder wohnen auch teils beim anderen Elternteil. Ruhig und neutral.',
        },
        couple: {
            name: 'Paar',
            body: 'Zwei Erwachsene. Ein gemeinsamer Kalender, Einkäufe und was zu tun ist.',
        },
        solo: {
            name: 'Allein',
            body: 'Arbeit, Sport und Termine im Griff. Kurz und übersichtlich.',
        },
        student: {
            name: 'Studenten-WG',
            body: 'Ein fairer Putzplan, Einkäufe und eine Pinnwand. Die Tafel im Flur weiß, wer mit dem Abwasch dran ist.',
        },
        shared: {
            name: 'Mitbewohner',
            body: 'Eine geteilte Wohnung unter Erwachsenen. Ein fairer Plan und eine Tafel im Flur.',
        },
        cohousing: {
            name: 'Wohnprojekt oder Hofgemeinschaft',
            body: 'Eigene Wohnungen mit einem Gemeinschaftsraum. Ein Kalender für den Gemeinschaftsraum, Nachrichten und wer putzt.',
        },
        senior: {
            name: 'Ältere Menschen zu Hause',
            body: 'Selbstständig zu Hause. Große Schrift, Termine, Erinnerungen (auch an Medikamente) und das Wetter.',
        },
        care: {
            name: 'Ältere zu Hause, Familie schaut mit',
            body: 'Jemand, der allein wohnt, und Familie, die aus der Ferne mitschaut. Große Schrift, wenige Knöpfe.',
        },
    },
    short: {
        family: 'Familie',
        two_home: 'Familie mit zwei Zuhause',
        couple: 'Paar',
        solo: 'Allein',
        student: 'Studenten-WG',
        shared: 'Mitbewohner',
        cohousing: 'Wohnprojekt',
        senior: 'Ältere zu Hause',
        care: 'Ältere mit Familie',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'Schaut Familie aus der Ferne mit?',
    yes: 'Ja',
    no: 'Nein',
    laterNote: 'Mehrere Generationen unter einem Dach? Wähle Familie mit Kindern.',
    modulesOn: 'Das schalten wir für euch ein',
    modulesOnHint: 'Passt das? Du kannst jeden Teil später in den Einstellungen ein- oder ausschalten.',
    confirm: 'Passt, weiter',
    settingsTitle: 'Art des Haushalts',
    settingsBody: 'Familie, Mitbewohner, allein …',
    settingsIntro: 'Die Art bestimmt, welche Teile standardmäßig an sind, wie die App aussieht und ein paar Wörter. Es wird nie etwas gelöscht.',
    current: 'Aktuell gewählt',
    choose: 'Andere Art wählen',
    previewTitle: 'Was ändert sich?',
    turnsOn: 'Wird eingeschaltet',
    turnsOff: 'Wird ausgeschaltet',
    turnsOffNote: 'Was darin steht, bleibt gespeichert. Schaltest du es später wieder ein, ist alles noch da.',
    kept: 'Bleibt, wie ihr es gewählt habt',
    nothingChanges: 'Die Teile bleiben, wie sie sind. Nur das Aussehen und ein paar Wörter ändern sich.',
    lookChanges: 'Auch das Aussehen passt sich an.',
    resetChoices: 'Auch unsere eigenen Einstellungen bei Module auf Standard zurücksetzen',
    apply: 'Wechseln zu {name}',
    cancel: 'Nicht wechseln',
    toast: 'Euer Haushalt ist jetzt: {name}. Es wurde nichts gelöscht.',
    onlyParents: 'Nur eine verwaltende Person kann das ändern.',
    words: {
        family: {
            members: 'Familienmitglieder',
            profileTitle: 'Was passt zu eurer Familie?',
            weatherBody: 'Jacke, Stiefel oder Sonnencreme: Wir sagen es, wenn die Kinder aus dem Haus gehen.',
            adult: 'Elternteil',
            tasks: 'Aufgaben',
            cleaning: 'Putzen',
            household: 'Familie',
            admin: 'Elternteil',
        },
        adults: {
            members: 'Wer hier wohnt',
            profileTitle: 'Was passt zu euch?',
            weatherBody: 'Jacke, Schirm oder Sonnencreme: Wir sagen es kurz bevor du aus dem Haus gehst.',
            adult: 'Erwachsene Person',
            tasks: 'Aufgaben',
            cleaning: 'Putzen',
            household: 'Haushalt',
            admin: 'Verwaltung',
        },
        shared: {
            members: 'Mitbewohner',
            profileTitle: 'Was passt zu eurer WG?',
            weatherBody: 'Jacke, Schirm oder Sonnencreme: auf dem Board im Flur, kurz bevor du aus dem Haus gehst.',
            adult: 'Mitbewohner',
            tasks: 'Aufgaben',
            cleaning: 'Putzen',
            household: 'WG',
            admin: 'Verwaltung',
        },
        care: {
            members: 'Familie',
            profileTitle: 'Was passt zu euch?',
            weatherBody: 'Jacke, Schirm oder Sonnencreme: Wir sagen es kurz bevor du aus dem Haus gehst.',
            adult: 'Erwachsene Person',
            tasks: 'Aufgaben',
            cleaning: 'Putzen',
            household: 'Haushalt',
            admin: 'Pflegende Person',
        },
    },
    greetingHouse: 'Schön, dich zu sehen',
    wizardRotationTitle: 'Ein fairer Putzplan',
    wizardRotationBody: 'Küche, Bad, Flur, Müll und Abwasch wechseln jede Woche, und jeden Abend kocht jemand anderes. Das Board im Flur zeigt, wer dran ist.',
    wizardAdultsTitle: 'Bereit zum Start',
    wizardAdultsBody: 'Trag deine Termine in den Kalender ein und behalte im Blick, was zu tun ist. Dein Handy gibt Bescheid, wenn es hilft.',
    wizardMembersShared: 'Wer wohnt im Haus? Du kannst später allen einen eigenen Login geben.',
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'Wer dazugehört',
        profileTitle: 'Was passt zu dir?',
        profileBody: 'Wähle Küche, Glaube und Essen, dann siehst du vor allem, was zu dir passt. Das ist freiwillig.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'Bewohner',
        profileTitle: 'Was passt zu eurem Wohnprojekt?',
        household: 'Wohnprojekt',
        adult: 'Bewohner',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'Wer hier wohnt',
            membersIntro: 'Alle, die auf der Tafel stehen. Die Farbe jeder Person siehst du überall.',
            membersAdd: 'Person',
            membersAddLong: 'Person hinzufügen',
            membersNew: 'Neue Person',
            namePlaceholder: 'Zum Beispiel Noor',
            face: 'Symbol',
            kidLockTitle: 'Tablet-Sperre',
            kidLockBody: 'Eine PIN, bevor jemand auf dem Tablet etwas abhakt. Standardmäßig aus.',
            exportAll: 'Alle',
            devicesIntro: 'Die Tablets, auf denen eure Tafel läuft.',
            library: 'Aufgabenideen',
            libraryIntro: 'Wähle eine Aufgabe und für wen sie ist.',
            wizardMembersTitle: 'Wer wohnt hier?',
            wizardMembersBody: 'Gib allen eine eigene Farbe. Du siehst sie überall wieder.',
            noTasksTitle: 'Heute keine Aufgaben',
            noTasksBody: 'Alles erledigt.',
            tasksWidget: 'Aufgaben heute',
            tasksAll: 'Alle Aufgaben',
            tasksEmptyBody: 'Fang mit etwas Kleinem an, etwa der Wäsche oder den Pflanzen.',
            exportBody: 'Lade den Kalender als .ics-Datei herunter, für alle oder pro Person.',
            dataBody: 'Eine Kopie eurer Daten als Datei (JSON), auch die Auswahl bei {profile}. Du bestätigst zuerst mit deinem Passwort.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles herunterladen, jemanden entfernen oder die Tafel löschen.',
            approvalHint: 'Jemand anderes prüft die Aufgabe, bevor sie als erledigt zählt.',
            supportIntro: 'Brauchst du Hilfe? Dann kann AMUMIN eine Zeit lang mitschauen, nur lesend. Du bestimmst, wie lange, und jede verwaltende Person kann es jederzeit sofort beenden.',
            supportOff: 'Aus. Niemand von AMUMIN kann eure Tafel sehen.',
            supportSees: 'AMUMIN sieht dann: die Namen aller auf der Tafel, die Titel der Termine von heute und den nächsten 6 Tagen (in einem Titel kann etwas wie Zahnarzt stehen; Termine mit einem Glaubenssymbol wie Moschee oder Kirche nicht), die Räume und die Tablets. Nicht: Glaube, Gesundheit, Schule, E-Mail-Adressen oder Fotos. Jedes Mitschauen siehst du unten.',
        },
        solo: {
            membersTitle: 'Wer dazugehört',
            membersIntro: 'Du und alle, die du später hinzufügst. Deine Farbe siehst du überall.',
            membersAdd: 'Person',
            membersAddLong: 'Person hinzufügen',
            membersNew: 'Neue Person',
            namePlaceholder: 'Zum Beispiel Noor',
            face: 'Symbol',
            kidLockTitle: 'Tablet-Sperre',
            kidLockBody: 'Eine PIN, bevor jemand auf dem Tablet etwas abhakt. Standardmäßig aus.',
            exportAll: 'Alles',
            devicesIntro: 'Die Tablets, auf denen deine Tafel läuft.',
            library: 'Aufgabenideen',
            libraryIntro: 'Wähle eine Aufgabe, die du öfter erledigst.',
            wizardMembersTitle: 'Noch jemand?',
            wizardMembersBody: 'Du stehst schon auf der Tafel. Gehört noch jemand dazu, zum Beispiel für gemeinsame Termine? Füge die Person hier oder später hinzu.',
            noTasksTitle: 'Heute keine Aufgaben',
            noTasksBody: 'Alles erledigt.',
            tasksWidget: 'Aufgaben heute',
            tasksAll: 'Alle Aufgaben',
            tasksEmptyBody: 'Fang mit etwas Kleinem an, etwa der Wäsche oder den Pflanzen.',
            exportBody: 'Lade den Kalender als .ics-Datei herunter, für alle oder pro Person.',
            dataBody: 'Eine Kopie eurer Daten als Datei (JSON), auch die Auswahl bei {profile}. Du bestätigst zuerst mit deinem Passwort.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles herunterladen, jemanden entfernen oder die Tafel löschen.',
            approvalHint: 'Du prüfst die Aufgabe selbst, bevor sie als erledigt zählt.',
            supportIntro: 'Brauchst du Hilfe? Dann kann AMUMIN eine Zeit lang mitschauen, nur lesend. Du bestimmst, wie lange, und du kannst es jederzeit sofort beenden.',
            supportOff: 'Aus. Niemand von AMUMIN kann deine Tafel sehen.',
            supportSees: 'AMUMIN sieht dann: die Namen aller auf der Tafel, die Titel der Termine von heute und den nächsten 6 Tagen (in einem Titel kann etwas wie Zahnarzt stehen; Termine mit einem Glaubenssymbol wie Moschee oder Kirche nicht), die Räume und die Tablets. Nicht: Glaube, Gesundheit, Schule, E-Mail-Adressen oder Fotos. Jedes Mitschauen siehst du unten.',
        },
        shared: {
            membersTitle: 'Mitbewohner',
            membersIntro: 'Alle, die im Haus wohnen. Die Farbe jeder Person siehst du überall.',
            membersAdd: 'Mitbewohner',
            membersAddLong: 'Mitbewohner hinzufügen',
            membersNew: 'Neuer Mitbewohner',
            namePlaceholder: 'Zum Beispiel Sanne',
            face: 'Symbol',
            kidLockTitle: 'Tablet-Sperre',
            kidLockBody: 'Eine PIN, bevor jemand auf dem Tablet im Flur etwas abhakt. Standardmäßig aus.',
            exportAll: 'Ganzes Haus',
            devicesIntro: 'Die Tablets, auf denen die Tafel im Haus läuft.',
            library: 'Aufgabenideen',
            libraryIntro: 'Wähle eine Aufgabe und wer sie macht.',
            wizardMembersTitle: 'Wer wohnt hier?',
            wizardMembersBody: 'Wer wohnt im Haus? Du kannst später allen einen eigenen Login geben.',
            noTasksTitle: 'Heute keine Aufgaben',
            noTasksBody: 'Im Putzplan siehst du, wer was macht.',
            tasksWidget: 'Aufgaben heute',
            tasksAll: 'Alle Aufgaben',
            tasksEmptyBody: 'Fang mit etwas Kleinem an, etwa den Müll rausbringen.',
            exportBody: 'Lade den Kalender als .ics-Datei herunter, für alle oder pro Person.',
            dataBody: 'Eine Kopie eurer Daten als Datei (JSON), auch die Auswahl bei {profile}. Du bestätigst zuerst mit deinem Passwort.',
            dataAll: 'Ganzes Haus',
            privacyEntryBody: 'Alles herunterladen, jemanden entfernen oder die Tafel löschen.',
            approvalHint: 'Eine Mitbewohnerin oder ein Mitbewohner prüft die Aufgabe, bevor sie als erledigt zählt.',
            supportIntro: 'Brauchst du Hilfe? Dann kann AMUMIN eine Zeit lang mitschauen, nur lesend. Du bestimmst, wie lange, und jede verwaltende Person im Haus kann es jederzeit sofort beenden.',
            supportOff: 'Aus. Niemand von AMUMIN kann die Tafel eures Hauses sehen.',
            supportSees: 'AMUMIN sieht dann: die Namen aller auf der Tafel, die Titel der Termine von heute und den nächsten 6 Tagen (in einem Titel kann etwas wie Zahnarzt stehen; Termine mit einem Glaubenssymbol wie Moschee oder Kirche nicht), die Räume und die Tablets. Nicht: Glaube, Gesundheit, Schule, E-Mail-Adressen oder Fotos. Jedes Mitschauen siehst du unten.',
        },
        care: {
            membersTitle: 'Familie',
            membersIntro: 'Alle, die mithelfen oder auf der Tafel stehen. Die Farbe jeder Person siehst du überall.',
            membersAdd: 'Person',
            membersAddLong: 'Person hinzufügen',
            membersNew: 'Neue Person',
            namePlaceholder: 'Zum Beispiel Anja',
            face: 'Symbol',
            kidLockTitle: 'Tablet-Sperre',
            kidLockBody: 'Eine PIN, bevor jemand auf dem Tablet etwas abhakt. Standardmäßig aus.',
            exportAll: 'Alle',
            devicesIntro: 'Die Tablets, auf denen die Tafel läuft.',
            library: 'Aufgabenideen',
            libraryIntro: 'Wähle eine Aufgabe und für wen sie ist.',
            wizardMembersTitle: 'Wer hilft mit?',
            wizardMembersBody: 'Füge alle hinzu, die mithelfen oder auf der Tafel stehen sollen. Jede Person bekommt eine eigene Farbe.',
            noTasksTitle: 'Heute keine Aufgaben',
            noTasksBody: 'Alles erledigt.',
            tasksWidget: 'Aufgaben heute',
            tasksAll: 'Alle Aufgaben',
            tasksEmptyBody: 'Fang mit etwas Kleinem an, etwa Medikamente oder Einkäufe.',
            exportBody: 'Lade den Kalender als .ics-Datei herunter, für alle oder pro Person.',
            dataBody: 'Eine Kopie eurer Daten als Datei (JSON), auch die Auswahl bei {profile}. Du bestätigst zuerst mit deinem Passwort.',
            dataAll: 'Alles',
            privacyEntryBody: 'Alles herunterladen, jemanden entfernen oder die Tafel löschen.',
            approvalHint: 'Eine verwaltende Person prüft die Aufgabe, bevor sie als erledigt zählt.',
            supportIntro: 'Brauchst du Hilfe? Dann kann AMUMIN eine Zeit lang mitschauen, nur lesend. Du bestimmst, wie lange, und jede verwaltende Person kann es jederzeit sofort beenden.',
            supportOff: 'Aus. Niemand von AMUMIN kann eure Tafel sehen.',
            supportSees: 'AMUMIN sieht dann: die Namen aller auf der Tafel, die Titel der Termine von heute und den nächsten 6 Tagen (in einem Titel kann etwas wie Zahnarzt stehen; Termine mit einem Glaubenssymbol wie Moschee oder Kirche nicht), die Räume und die Tablets. Nicht: Glaube, Gesundheit, Schule, E-Mail-Adressen oder Fotos. Jedes Mitschauen siehst du unten.',
        },
    },
    rotation: {
        title: 'Putzplan',
        intro: 'Aufgaben wechseln fair: Wer dran war, stellt sich hinten an. Wer weg ist, setzt einmal aus und ist danach wieder als Erstes dran.',
        thisWeek: 'Diese Woche',
        today: 'Heute',
        nextUp: 'Danach',
        weekOf: 'Woche vom {date}',
        nobody: 'Niemand macht mit',
        done: 'Erledigt von {name}',
        notYet: 'Noch nicht erledigt',
        swapped: 'Getauscht',
        skipped: '{name} ist weg',
        swap: 'Tauschen',
        swapTitle: 'Wer macht {duty} {period}?',
        swapPeriodWeek: 'diese Woche',
        swapPeriodDay: 'heute',
        swapUndo: 'Tausch rückgängig machen',
        swapSaved: '{name} macht {duty}',
        swapRemoved: 'Der Tausch wurde rückgängig gemacht',
        away: 'Abwesend',
        awayTitle: 'Jemand ist eine Weile weg',
        awayBody: 'Im Urlaub oder beruflich unterwegs? Die Person setzt einmal aus und ist danach wieder als Erstes dran.',
        awayWho: 'Wer',
        awayFrom: 'Von',
        awayTo: 'Bis einschließlich',
        awayAdd: 'Als abwesend eintragen',
        awayRemove: 'Wieder da',
        awayItem: '{name}: {from} bis {to}',
        awaySaved: '{name} ist als abwesend eingetragen',
        awayRemoved: '{name} ist wieder da',
        awayInvalid: 'Das Enddatum liegt vor dem Startdatum.',
        empty: 'Noch kein Putzplan',
        emptyBody: 'Erstelle einen Plan mit Küche, Bad, Flur, Müll, Abwasch und Kochen. Danach kannst du bei Putzen Aufgaben entfernen oder hinzufügen.',
        setup: 'Putzplan erstellen',
        setupDone: '{count} Aufgaben stehen im Plan',
        setupNothing: 'Diese Aufgaben stehen schon im Plan',
        weekly: 'Jede Woche',
        daily: 'Jeden Tag',
        others: 'Andere Aufgaben',
        othersBody: 'Aufgaben aus Putzen, die noch nicht wechseln.',
        makeWeekly: 'Jede Woche wechseln',
        makeDaily: 'Jeden Tag wechseln',
        stopRotating: 'Nicht mehr wechseln',
        rotatingOn: '{duty} wechselt jetzt',
        rotatingOff: '{duty} wechselt nicht mehr',
        onBoard: 'Das Board im Flur zeigt, wer diese Woche dran ist. Abhaken geht dort mit einem Tipp.',
        duties: {
            kitchen: 'Küche',
            bathroom: 'Bad',
            hallway: 'Flur und Treppe',
            trash: 'Müll',
            dishes: 'Abwasch',
            cooking: 'Kochen',
        },
    },
};
//# sourceMappingURL=householdsApp.de.js.map